import { StandardEvents } from '@shopify/events';

function refresh(open = false) {
  return window.RaceCodeCart?.refresh(open);
}

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  try {
    await event.promise;
    await refresh(event.action === 'add');
  } catch (error) {
    console.error('[Race Code cart]', error);
  }
});

document.addEventListener(StandardEvents.cartDiscountUpdate, () => refresh());

window.addEventListener('pageshow', (event) => {
  const navigation = performance.getEntriesByType('navigation')[0];
  if (event.persisted || navigation?.type === 'back_forward') refresh();
});

function configureActions() {
  const actions = window.Shopify?.actions;
  if (!actions?.openCart?.configure) return;
  actions.openCart.configure({
    async handler() {
      const drawer = document.querySelector('rc-cart-drawer-component');
      if (drawer?.open) {
        await refresh();
        drawer.open();
      } else {
        window.location.href = window.Theme?.routes?.cart_url || '/cart';
      }
    },
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', configureActions, { once: true });
} else {
  configureActions();
}
